import React from 'react';
import { Link } from 'react-router-dom';

const ThemeArticles = (props) => {
    const RenderArticles = () => {
        const { fields } = props;
        if (fields) {
            const render = fields.selectedarticles_list.map((value, index) => {
                return (
                    <div className="theme__article" key={index}>
                        <div className="readmore__inner-container readmore__inner-container--blue">
                            <h3 className="text__color--white readmore__title--theme">
                                {value.selectedarticles_list_title}
                            </h3>
                            <p>{value.selectedarticles_list_body}</p>
                            {value.selectedarticles_list_extlink && (
                                <a
                                    href={value.selectedarticles_list_extlink}
                                    className="cta-btn--external white"
                                    target="_blank">
                                    Read article
                                </a>
                            )}
                            {value.selectedarticles_list_post.post_name && (
                                <Link
                                    className="cta-btn white"
                                    to={{
                                        pathname: `/actueel/${value.selectedarticles_list_post.post_name}/`,
                                        state: { transition: 'fade' },
                                    }}>
                                    Read article
                                </Link>
                            )}
                        </div>
                    </div>
                );
            });
            return render;
        } else {
            return '';
        }
    };

    return (
        <React.Fragment>
            {props.fields.selectedarticles_list && (
                <section className="theme__container fadeIn">
                    <div className="content-container">
                        <div className="theme__article--intro">
                            <h3>Selected articles</h3>
                            <p>
                                {props.fields &&
                                    props.fields.selectedarticles_intro}
                            </p>
                        </div>
                        <div className="theme__holder">
                            {<RenderArticles />}
                        </div>
                    </div>
                </section>
            )}
        </React.Fragment>
    );
};
export default ThemeArticles;



// WEBPACK FOOTER //
// ./src/components/Pages/Themes/ThemeArticles.jsx